import { IconButton } from '@mui/material'
import { UserItemContext } from 'Components/_common/SearchUser/UserItemContext'
import { useContext } from 'react'
import { Else, If, Then, When } from 'react-if'
import FAIcon from 'Theme/FAIcon'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'

export const JudgeControls = ({
  contestId,
  ownerId,
  userIds,
  saveJudge,
  deleteJudge,
  isDeleteJudgeLoading,
  isSaveJudgeLoading,
}) => {
  const { user } = useContext(UserItemContext)

  const handleAddJudgeToTheContest = (user) => {
    saveJudge({ payload: { user_id: user.id } })
  }

  return (
    <When condition={ownerId !== user?.id}>
      <If condition={userIds.includes(user?.id)}>
        <Then>
          <IconButton
            disabled={isDeleteJudgeLoading}
            onClick={() => deleteJudge({ contestId, judgeId: user?.id })}
          >
            <FAIcon
              iconFontSize={12}
              iconClassName={FA_ICONS.CLOSE}
            />
          </IconButton>
        </Then>
        <Else>
          <IconButton
            disabled={isSaveJudgeLoading}
            onClick={() => handleAddJudgeToTheContest(user)}
          >
            <FAIcon
              iconFontSize={12}
              iconClassName={FA_ICONS.USER_PLUS}
              color="secondary.main"
            />
          </IconButton>
        </Else>
      </If>
    </When>
  )
}
